import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { OnyxEvent } from '../models/event';
import { Party } from '../models/party';
import { PartyForUnmatchEvent } from '../models/party-for-unmatch-event';
import { PopupType } from '../models/property-popup-type.enum';
import { UnmatchEventPartyRequest } from '../models/unmatch-event-party-request';
import { UnmatchEventRequest } from '../models/unmatch-event-request';
@Component({
  selector: 'pioneer-unmatch-event-modal',
  templateUrl: './unmatch-event-popup.component.html'
})
export class UnmatchEventPopupComponent implements OnInit {

  @Input()
  public event: OnyxEvent;

  @Output()
  public closed = new EventEmitter();

  public agency: PartyForUnmatchEvent;
  public vendors: PartyForUnmatchEvent[];
  public reasonForUnmatch = '';

  public isPartySelected = new Map();

  public PopupType = PopupType;

  @ViewChild(ModalDirective)
  public unmatchEventModal: ModalDirective;

  get isShown(): boolean { return this.unmatchEventModal.isShown; }

  constructor() { }

  public ngOnInit() {
    this.agency = new PartyForUnmatchEvent({});
    this.vendors = [];
    this.isPartySelected = new Map();
    this.reasonForUnmatch = '';
  }

  public open(): void {
    this.setAgencyForUnmatchEvent();
    this.setVendorsForUnmatchEvent();
    this.unmatchEventModal.show();
  }

  public onUnmatch(): void {
    let parties: UnmatchEventPartyRequest[] = [];

    if (this.isAgencySelected()) {
      const party: UnmatchEventPartyRequest = new UnmatchEventPartyRequest({
        type: this.agency.type,
        code: this.agency.code
      });
      parties.push(party);
    } else {
      this.isPartySelected.forEach(function(value, key) {
        parties.push(value);
      });
    }

    const unmatchEventRequest: UnmatchEventRequest = new UnmatchEventRequest({
      action: (parties[0].type === 'AGENCY' ? 'UNMATCH_AGENCY' : 'UNMATCH_VENDOR'),
      event_id: this.event.eventId,
      parties: parties,
      reason: this.reasonForUnmatch,
      unmatched_by: null,
      party_initiator_type: null,
      party_initiator_code: null,
      event_info: null,
    });

    this.ngOnInit();
    this.unmatchEventModal.hide();
    this.closed.emit(unmatchEventRequest);
  }

  public onCancel() {
    this.ngOnInit();
    this.unmatchEventModal.hide();
  }

  public setAgencyForUnmatchEvent(): void {
    if (this.event && this.event.eventAgency) {
      this.agency = new PartyForUnmatchEvent({
        type: this.event.eventAgency.partyType,
        code: this.event.eventAgency.code,
        name: this.event.eventAgency.name,
        address: this.retrieveCompleteAddress(this.event.eventAgency)
      });
    }
  }

  setVendorsForUnmatchEvent(): void {
    if (this.event && this.event.eventVendors) {
      this.event.eventVendors.forEach(function addVendorForUnmatch(vendor) {
        if ((vendor.createdEvent && vendor.createdEvent === 'Y') || (vendor.mergedEvent && vendor.mergedEvent === 'Y')) {
          let party = new PartyForUnmatchEvent({
            type: vendor.partyType,
            code: vendor.code,
            name: vendor.name,
            address: this.retrieveCompleteAddress(vendor)
          });
          this.vendors.push(party);
        }
      }, this);
    }
  }

  retrieveCompleteAddress(vendor: Party): string {
    let address = '';
    if (vendor.line1 && vendor.line1.trim().length > 0) {
      address = address + vendor.line1.trim();
    }
    if (vendor.line2 && vendor.line2.trim().length > 0) {
      address = address + ' ' + vendor.line2.trim();
    }
    if (vendor.line3 && vendor.line3.trim().length > 0) {
      address = address + ' ' + vendor.line3.trim();
    }
    if (vendor.city && vendor.city.trim().length > 0) {
      address = address + ', ' + vendor.city.trim();
    }
    if (vendor.state && vendor.state.trim().length > 0) {
      address = address + ', ' + vendor.state.trim();
    }
    if (vendor.postalCode && vendor.postalCode.trim().length > 0) {
      address = address + ', ' + vendor.postalCode.trim();
    }
    if (vendor.countryCode && vendor.countryCode.trim().length > 0) {
      address = address + ', ' + vendor.countryCode.trim();
    }
    return address;
  }

  changeIsPartySelected(event: any, type: string, code: string): void {
    if (event.currentTarget.checked === true) {
      const party: UnmatchEventPartyRequest = new UnmatchEventPartyRequest({
        type: type,
        code: code
      });
      this.isPartySelected.set(type + '_' + code, party);
    } else {
      this.isPartySelected.delete(type + '_' + code);
    }
  }

  isAgencySelected(): boolean {
    const keys = Array.from(this.isPartySelected.keys());
    const found = keys.find(key => key.startsWith('AGENCY'));
    return (found && found.length > 0);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/unmatch-event-popup/unmatch-event-popup.component.ts